// extracted by mini-css-extract-plugin
export default {"drawerTitleCont":"Sidebar_drawerTitleCont__+jhk0"};